import { InjectionToken } from '@angular/core';


export class TokenHolder {
    private token: string;
    set value(v: string) {
        this.token = v;
    }
    get value(): string {
        return this.token;
    }
}

export const TOKEN_HOLDER = new InjectionToken<TokenHolder>('TokenHolder');
